import { supabase } from '@/integrations/supabase/client';

export async function signIn(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    throw error;
  }

  return data;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();

  if (error) {
    throw error;
  }
}

export async function getCurrentUser() {
  const { data: { user }, error } = await supabase.auth.getUser();

  if (error) {
    throw error;
  }

  return user;
}

export async function checkAdminAccess() {
  try {
    const user = await getCurrentUser();
    
    if (!user) {
      console.log('[AUTH] No user found');
      return false;
    }

    console.log('[AUTH] Checking admin access for user:', user.id);
    console.log('[AUTH] User email:', user.email);

    // Query admin_users table
    const { data: adminUser, error } = await supabase
      .from('admin_users')
      .select('*')
      .eq('id', user.id)
      .maybeSingle();

    console.log('[AUTH] Query result - data:', adminUser);
    console.log('[AUTH] Query result - error:', error);

    if (error) {
      console.error('[AUTH] Error checking admin access:', error);
      // Check if it's a permission error
      if (error.code === 'PGRST116' || error.message.includes('permission')) {
        console.error('[AUTH] RLS policy blocking access!');
      }
      return false;
    }

    if (!adminUser) {
      console.log('[AUTH] User not found in admin_users table');
      return false;
    }

    console.log('[AUTH] Admin user found:', adminUser);
    console.log('[AUTH] is_active:', adminUser.is_active);
    
    const hasAccess = adminUser.is_active === true;
    console.log('[AUTH] Final access decision:', hasAccess);
    
    return hasAccess;
  } catch (err) {
    console.error('[AUTH] Exception in checkAdminAccess:', err);
    return false;
  }
}